import dkAxios from '@/jslib/dk-axios'

export const Statistics = data => dkAxios({
  url: '/v1/cms/Statistics/total',
  method: 'POST',
  data,
});

export const StatisticsEchart = data => dkAxios({
  url: '/v1/cms/Statistics',
  method: 'GET',
  params: data,
});

export const getProductData = data => dkAxios({
  url: '/v1/cms/Statistics/getProductData',
  method: 'POST',
  params: data,
});

export const getExportUrlStatistics = data => dkAxios({
  url: '/v1/cms/Statistics/export',
  method: 'GET',
  params: data,
});



// WEBPACK FOOTER //
// ./src/api/statistics.js